import { render, staticRenderFns } from "./header-brand.vue?vue&type=template&id=548fbcfb&scoped=true&"
import script from "./header-brand.vue?vue&type=script&lang=js&"
export * from "./header-brand.vue?vue&type=script&lang=js&"
import style0 from "./header-brand.vue?vue&type=style&index=0&id=548fbcfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548fbcfb",
  null
  
)

export default component.exports